module.exports = __webpack_public_path__ + "static/media/10.bfe80a78.jpg";